<template>
    <bs-form :props="{height:this.$store.getters.formHeight,class:'console',ref:'pform',form:{ref:'cform',upload:this.$app.url.uploadApi}}"  :route="route"></bs-form>
</template>
<script>
export default {
  data() {
    return {
      route: { params: this.$route.params, query: this.$route.query }
    };
  },
  props: {},
  components: {
    BsForm: () => import("../../components/bs-form")
  },
  created() {},
  beforeMount() {},
  mounted() {},
  methods: {},
  watch: {
    $route: function(to, from) {
      this.route = { params: to.params, query: to.query };
    }
  }
};
</script>
